import { FiArrowLeft } from 'react-icons/fi';
export default FiArrowLeft;

//# sourceMappingURL=LightArrowLeft.js.map